import { Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { FoodsIcon } from "@foodpilot/foods";
import { useTranslation } from "react-i18next";
import { StatCard } from "./ConsentAdminShared";

type ConsentGovernanceSummaryCardsProps = {
    documentCount: number;
    optInCount: number;
    recordCount: number;
    versionCount: number;
};

export const ConsentGovernanceSummaryCards = ({
    documentCount,
    optInCount,
    recordCount,
    versionCount,
}: ConsentGovernanceSummaryCardsProps) => {
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <Stack direction={{ xs: "column", md: "row" }} gap={theme.spacing(2)} flexWrap="wrap">
            <StatCard
                icon={<FoodsIcon icon="documentation" size={2} />}
                value={documentCount}
                label={t("settings.consent.summary.documents", "Documents")}
                accentColor={theme.palette.error.main}
            />
            <StatCard
                icon={<FoodsIcon icon="settings" size={2} />}
                value={optInCount}
                label={t("settings.consent.summary.preferences", "Preferences")}
                accentColor={theme.palette.primary.main}
            />
            <StatCard
                icon={<FoodsIcon icon="viewPwd" size={2} />}
                value={versionCount}
                label={t("settings.consent.summary.versions", "Versions")}
                accentColor={theme.palette.info.main}
            />
            <StatCard
                icon={<FoodsIcon icon="check" size={2} />}
                value={recordCount}
                label={t("settings.consent.summary.records", "Records")}
                accentColor={theme.palette.success.main}
                highlighted
            />
        </Stack>
    );
};
